function integrationUnrestService($http, appConfig) {
    return {
        update(integrationPosCommand) {
            return $http.post(appConfig.apiUrl + 'integrationPos/update',
                integrationPosCommand, { withCredentials: true });
        }
    }
}
angular.module('qkr.integration.settings').factory('integrationUnrestService', integrationUnrestService);

           


// WEBPACK FOOTER //
// ./src/integration-settings/services/integration.unrest.service.js